export default __webpack_public_path__ + "static/media/cfc.18f32e55.png";